import { Spinner } from "@fluentui/react"
import React from "react"
import { FaCheckCircle } from "react-icons/fa"
import './must-click-link.scss'

type MustClickLinkProps = {
  url?: string
  label: string
  onClicked: (ev: React.MouseEvent<HTMLAnchorElement>) => void
  clicked: boolean
  loading?: boolean
}

export const MustClickLink = ({ url, label, onClicked, clicked, loading }: MustClickLinkProps) => {
  return <span className={["must-click mt-2", clicked ? 'clicked' : ''].join(' ')}>
    <a href={url || ''} target={url ? "_blank" : ''} onClick={ev => {
      if (!url) {
        ev.preventDefault()
      }
      
      onClicked(ev)
    }}>
      {label}
      <span className="mc-icon">
        {loading ? <Spinner /> : (
          clicked
            ? <FaCheckCircle color="green" fontSize="1.5em" />
            : <span className="unclicked">!</span>
        )}
      </span>
    </a>
  </span>
}

